<div id="nav-v2" class="p-fixed d-flex">
  <div class="main w-44px space-between-vert align-items-c">
    <div class="centered-content flex-d-c w-full pt-11px">
      <img src="dist/img/gtmhub-circle-logo.svg" class="mb-10px" />
      <span
        class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
        *ngFor="let screen of screens"
        (click)="setActive(screen)"
        ui-tooltip
        [tooltipContent]="screen.key | localize"
        tooltipPosition="right"
        [ngClass]="'gh-font-icon-' + screen.icon"
        [class.bg-white]="activeScreen === screen.key">
      </span>
    </div>
    <div class="centered-content flex-d-c pb-11px w-full">
      <span (click)="goToMarketplace()" gh-dropdown-toggle class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full gh-font-icon-add-from-marketplace"></span>
      <span
        class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
        *ngFor="let screen of supportScreens"
        (click)="setActive(screen)"
        ui-tooltip
        [tooltipContent]="screen.key | localize"
        tooltipPosition="right"
        [ngClass]="'gh-font-icon-' + screen.icon"
        [class.bg-white]="activeScreen === screen.key">
      </span>
      <gh-dropdown [menuItems]="helpMenuItems" [dropUp]="true">
        <span gh-dropdown-toggle class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full gh-font-icon-help"></span>
      </gh-dropdown>
      <gh-dropdown [menuItems]="profileMenuItems" [dropUp]="true" class="mt-18px" dropdownMenuClass="l--13px">
        <img gh-dropdown-toggle class="avatar" [src]="profile.picture" />
      </gh-dropdown>
    </div>
  </div>
  <sub-navigation [activeScreen]="activeScreen"></sub-navigation>
</div>
